import { useCallback, useEffect, useMemo, useState } from 'react';
import type { CSSProperties } from 'react';
import { AcademicProfile, Viewer, api } from '../../lib/api';

interface Props {
  user: Viewer;
  isAdmin: boolean;
  scope: 'full' | 'read';
}

export function AccountDataRail({ user, isAdmin, scope }: Props) {
  const [academic, setAcademic] = useState<AcademicProfile>();
  const load = useCallback(() => api<{ data: AcademicProfile }>('/api/v1/profile/academic').then((response) => setAcademic(response.data)).catch(() => undefined), []);

  useEffect(() => {
    void load();
    const refresh = () => void load();
    window.addEventListener('caigen:academic-updated', refresh);
    return () => window.removeEventListener('caigen:academic-updated', refresh);
  }, [load]);

  const roots = useMemo(() => [
    { label: '学籍', ready: Boolean(academic?.identity?.college || academic?.identity?.major), href: '#manual-data' },
    { label: '成绩', ready: Boolean(academic?.courseCount), href: '#academic-profile' },
    { label: '培养方案', ready: Boolean(academic?.credits.required), href: '#manual-data' },
    { label: '五育', ready: Boolean(academic?.youth), href: '#manual-data' },
  ], [academic]);
  const readyCount = roots.filter((item) => item.ready).length;
  const identity = academic?.identity;

  return <>
    <section className="paper-card identity-card identity-card--academic">
      <div className="account-avatar">{(user.displayName || '根').slice(0, 1)}</div>
      <h2>{user.displayName}</h2><p>{user.email}</p>
      <dl>
        <div><dt>学院</dt><dd>{identity?.college || user.profile?.school || '待补全'}</dd></div>
        <div><dt>专业</dt><dd>{identity?.major || user.profile?.major || '待补全'}</dd></div>
        <div><dt>年级</dt><dd>{identity?.grade || user.profile?.grade || '待补全'}</dd></div>
        <div><dt>权限</dt><dd>{isAdmin ? '管理员' : scope === 'read' ? '只读' : '成员'}</dd></div>
      </dl>
    </section>

    <section className="paper-card data-root-card">
      <header><span style={{ '--root-progress': `${readyCount / roots.length * 100}%` } as CSSProperties}><b>{readyCount}</b><small>/ {roots.length}</small></span><div><small>DATA ROOTS</small><h3>数据根脉</h3><p>{readyCount === roots.length ? '四类成长数据已经贯通。' : `还有 ${roots.length - readyCount} 类数据等待补全。`}</p></div></header>
      <nav>{roots.map((item) => <a key={item.label} href={item.href} className={item.ready ? 'ready' : ''}><i /> <span>{item.label}</span><small>{item.ready ? '已连接' : '待补全'}</small></a>)}</nav>
      <a className="root-connect-link" href="#data-connection">管理数据连接</a>
    </section>

    <section className="paper-card account-index-card">
      <h3>本页目录</h3>
      <a href="#data-connection"><span>01</span>南大数据连接</a>
      <a href="#data-permission"><span>02</span>隐私与授权</a>
      <a href="#academic-profile"><span>03</span>成长画像</a>
      <a href="#goal-planner"><span>04</span>目标与差距</a>
      <a href="#manual-data"><span>05</span>手动补全</a>
      <a href="#preference-center"><span>06</span>日常节律</a>
      <a href="#whaleu-subscription"><span>07</span>信库订阅</a>
      <a href="#device-access"><span>08</span>设备与令牌</a>
    </section>
  </>;
}
